import { Check } from "lucide-react";

const ToggleRow = ({ label }) => (
  <div className="flex items-center gap-2 my-[1.5rem]">
    <div className="bg-primary pl-10 rounded-full pr-1 w-12 h-6 flex items-center justify-end">
      <div className="bg-white p-0.5 rounded-full h-5 w-5 flex items-center justify-center">
        <Check color="var(--color-primary)" height={15} />
      </div>
    </div>
    <p className="text-sm text-secondary font-medium">{label}</p>
  </div>
);
export default ToggleRow;